export default "__VITE_ASSET__BMiluCNE__"